/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./policy.defs.js";
export { main as default } from "./policy.defs.js";
